import { render, staticRenderFns } from "./Employee2Select.vue?vue&type=template&id=0b97687a&scoped=true"
import script from "./Employee2Select.vue?vue&type=script&lang=js"
export * from "./Employee2Select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b97687a",
  null
  
)

export default component.exports